import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "../../../utils/router";
import { getLink, toast } from "../../../utils/helpers";
import { request } from "../../../utils/request";
import Loader from "../../general/Loader";
import Form from "./Form";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";

const Edit = () => {
    const { id } = useParams();

    const [movimiento, setMovimiento] = useState();
    const [items, setItems] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [errors, setErrors] = useState({});
    const history = useHistory();

    const goToGrid = () => history.push(getLink('/productos/inventario-masivo'));

    const edit = async (e) => {
        setErrors({});

        const formData = new FormData(e.target);
        const data = {};

        for (const [key, value] of formData.entries()) {
            const match = key.match(/^productos\[(\d+)\]\[(\w+)\]$/);

            if (match) {
                const [, index, campo] = match;

                if (!data.productos) {
                    data.productos = [];
                }

                if (!data.productos[index]) {
                    data.productos[index] = {};
                }

                data.productos[index][campo] = value;
            } else {
                data[key] = value;
            }
        }

        const token = auth.getToken();
        const res = await fetch(apiUrl(`movimientos/${id}`), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
                "X-Scopes": auth.getUser().rol,
            },
            body: JSON.stringify(data)
        });

        const response = await res.json();

        if (!response.success) {
            setErrors(response.data.message);
            toast('Error guardando los cambio del ajuste masivo de inventario', 'error');
            return
        }

        toast('Cambios guardados con éxito');
        goToGrid();
    };

    const getItems = async (url = null) => {
		url = url ? url + "&limit=100000" : "productos?limit=100000";
		const productos = await request(url);

        setItems(productos.data ?? []);
	};

    const getMovimiento = () => {
        request("movimientos/" + id).then((res) => {
            setMovimiento(res.data);
        });
    };

    const getCategorias = () => {
        request("grupos").then((res) => setCategorias([{ value: undefined, label: "Sin Categorías"}, ...res.data.map(item => ({ value: item.id, label: item.nombre}))]));
    };

    useEffect(() => {
        getItems();
        getMovimiento();
        getCategorias();
    }, []);

    return <div className="crear-compra">
        <div className="page-controls">
            <div className="page-header">
                <div className="page-title d-flex">
                    <button className="btn btn-secondary my-auto" onClick={goToGrid}><i className="fas fa-arrow-left"></i></button>
                    <div className="mx-2 d-flex flex-column">
                        <h2 className="m-0 p-0" style={{fontWeight: 500}}>Editar ajuste de inventario masivo</h2>
                        <small>Registre los productos y cantidades para realizar el ajuste de inventario</small>
                    </div>
                </div>
            </div>

            {!!movimiento
                ? <Form movimiento={movimiento} items={items} onSave={edit} onCancel={goToGrid} errors={errors} categorias={categorias} />
                : <Loader />
            }
        </div>
    </div>;
};

export default Edit;
